import Vue from 'vue'
import axios from 'axios'
// @ts-ignore
import App from '../src/App.vue'
import store from './store'
import router from './router/index'
import './registerServiceWorker'
import { i18n } from './pages/init'
import './pages/init.ts'
import VueLazyload from 'vue-lazyload'
// @ts-ignore
import loading from '@/assets/imageloader.gif'
// @ts-ignore
import error from '@/assets/img/no-photo-available.png'
import { fbConnector, gmailConnector, googleAnalytics } from '@/plugins/globals'
import ProductZoomer from 'vue-product-zoomer'
import '../src/theme/theme.scss'

// import 'material-design-icons-iconfont/dist/material-design-icons.css'
// import '@mdi/font/css/materialdesignicons.css'

Vue.mixin({
  methods: {
    intoNumber: function (input: any) {
      return parseFloat(input.toString()).toFixed(4)
    },
  },
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: error,
  loading: loading,
  attempt: 3,
  observer: true,
  listenEvents: ['scroll'],
})

Vue.use(ProductZoomer)

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common['Sector-ID'] = ''
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL + ''

Vue.config.productionTip = false
if (!process.env.VUE_APP_HAS_HOME_PAGE || process.env.VUE_APP_HAS_HOME_PAGE != 1) {
  window.location.href = '/catalog.html'
} else {
  new Vue({
    router,
    store,
    i18n,

    render: (h) => h(App),
  }).$mount('#app')
}

let facebookConnector = new fbConnector()
facebookConnector.initFB()

let gm = new gmailConnector()
gm.initGmail()

let ga = new googleAnalytics()
ga.gaInit()
